import { createContext } from 'react'
import type { ProjectLabel } from '@bandos/shared'

export interface LabelContextType {
  labels: ProjectLabel[]
  isLoading: boolean
  loadLabels: (mindmapId: string) => Promise<void>
  /** Set project labels directly (used for public/read-only mode) */
  setLabelsDirectly: (labels: ProjectLabel[]) => void
  createLabel: (mindmapId: string, labelText: string, color: string) => Promise<ProjectLabel | null>
  deleteLabel: (mindmapId: string, labelId: string) => Promise<boolean>
  addLabelToNode: (mindmapId: string, nodeId: string, labelId: string) => Promise<boolean>
  removeLabelFromNode: (mindmapId: string, nodeId: string, labelId: string) => Promise<boolean>
  getNodeLabels: (nodeId: string) => ProjectLabel[]
  setNodeLabels: (nodeId: string, labels: ProjectLabel[]) => void
  setNodeLabelsBatch: (updates: Array<{ nodeId: string; labels: ProjectLabel[] }>) => void
  reloadNodeLabels: (mindmapId: string, nodeId: string) => Promise<void>
  nodeLabelsVersion: number // Version counter to trigger re-renders
}

export const LabelContext = createContext<LabelContextType | undefined>(undefined)
